import React, { FunctionComponent, useState, useContext } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthContext } from './auth-context';
import { LoginModal } from './login';

import Sidebar from './components/SidebarNav';  // Import the Sidebar component

import Home from './pages/home';
import TeamSheets from './pages/sheets';
import RFA from './pages/rfa';
import FreeAgency from './pages/free-agency';
import Admin from './pages/admin';
import DraftGrades from './pages/draft-grades';
import SeasonPreview from './pages/season-preview';

const App: FunctionComponent = () => {


  const { user, checkSession, logout } = useContext(AuthContext);
  const [showLogin, setShowLogin] = useState(false);  
  
  const handleLoginClose = () => setShowLogin(false);

  const handleSignOut = () => {
    logout();
    checkSession();
    window.location.reload()
  };

  return (
    <>
        {showLogin && <LoginModal onClose={handleLoginClose} />}
          <div className={`main-content ${showLogin ? 'blurred' : ''}`}>
            <div className={'container'}>
                <div className={'login'}>
                {!user.session ? (
                        <button className={'button sign-in-attention'} onClick={() => setShowLogin(true)}>Sign In</button>
                    ) : (
                        <button className={'button'} onClick={handleSignOut}>Sign Out</button>
                    )}
                </div>
            </div>
            <Router>
              <Sidebar />
              <main className="page-content">
                <Routes>
                  <Route path='/' element={<Home />} />
                  <Route path='/sheets' element={<TeamSheets />} />
                  <Route path='/rfa' element={<RFA />} />
                  <Route path='/free-agency' element={<FreeAgency />} />
                  <Route path='/draft-grades' element={<DraftGrades />} />
                  <Route path='/season-preview' element={<SeasonPreview />} />
                  <Route path='/admin' element={<Admin />} />
                </Routes>
              </main>
            </Router> 
          </div>
    </>
    );
  };

export default App;
